import { createContext, useCallback, useReducer } from "react";
import PackagesReducer from "./PackagesReducer";
import { getPackages } from "./apiCalls"; // change to your actual path

const INITIAL_STATE = {
    packages: [],
    isFetching: false,
    error: false,
    hasFetched: false,
};

export const PackagesContext = createContext(INITIAL_STATE);

export const PackagesContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(
        PackagesReducer,
        INITIAL_STATE
    );

    const fetchPackages = useCallback(
        async (toast, forceRefresh = false) => {
            // Already fetched → don't make another API request
            if (state.hasFetched && !forceRefresh) {
                return;
            }

            await getPackages(dispatch, toast);
        },
        [state.hasFetched]
    );

    return (
        <PackagesContext.Provider
            value={{
                packages: state.packages,
                isFetching: state.isFetching,
                error: state.error,
                hasFetched: state.hasFetched,
                dispatch,
                fetchPackages,
            }}
        >
            {children}
        </PackagesContext.Provider>
    );
};